export default {
  active_orders: {
    title: 'Pedidos activos',
  },
  order_history: {
    title: 'Historial de pedidos',
  },
  menu: {
    title: 'Menú',
  },
  printer_settings: {
    title: 'Configuración de impresora',
  },
  order_control: {
    title: 'Control de pedidos',
  },
  busy_mode: {
    title_zero: 'Modo ocupado',
    title_other: 'Modo ocupado (+{{time}} min)',
  },
  volume: {
    title: 'Volumen',
  },
  switch_language: {
    title: 'Cambiar idioma ({{language}})',
  },
  logout: {
    title: 'Cerrar sesión',
    description: '¿Seguro que quieres cerrar sesión?',
    buttons: {
      confirm: 'Sí',
      cancel: 'Cancelar',
    },
  },
};
